import axios from "axios";
import AWS from "aws-sdk";
import crypto from "crypto-js";

const { shopName } =
	// @ts-ignore
	window.adminUiAppContext || {};

const S3_BUCKET = "woosent-dev";
const REGION = "us-east-1";

AWS.config.update({
	accessKeyId: "AKIAW5AIIC7ABGG4BNSM",
	secretAccessKey: "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",
	region: REGION,
});

const myBucket = new AWS.S3({
	params: { Bucket: S3_BUCKET },
	region: REGION,
});

export function sendBulkSms(
	phones: string[],
	message: string,
	accountSid: string,
	authToken: string,
	fromNumber: string,
) {
	return axios.post(
		`https://tygh3ygdt7.execute-api.us-east-1.amazonaws.com/Prod/message/`,
		{
			phones,
			message,
			accountSid,
			authToken,
			fromNumber,
		},
	);
}

export function sendBulkMms(
	phones: string[],
	message: string,
	accountSid: string,
	authToken: string,
	fromNumber: string,
	attachmentUrl: string,
) {
	return axios.post(
		`https://tygh3ygdt7.execute-api.us-east-1.amazonaws.com/Prod/message/`,
		{
			phones,
			message,
			accountSid,
			authToken,
			fromNumber,
			attachmentUrl,
		},
	);
}

export function uploadImageToS3(file: File) {
	try {
		const encryptedFileName =
			crypto.SHA256(file.name) + "." + file.type.split("/")[1];
		const params = {
			ACL: "public-read",
			Body: file,
			ContentType: file.type,
			Bucket: S3_BUCKET,
			Key: "campaigns/" + shopName + "/" + encryptedFileName,
		};

		return myBucket.upload(params).promise();
	} catch (error) {
		console.log(error);
		return;
	}
}
